import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilMarket } from "../../utils/market/utilMarket";
import { utilButton } from "../../utils/utilButton";
import { ButtonSecondaryAccentSmall } from "../generic/common/ButtonSecondaryAccentSmall";
import { GridItemContainerContract } from "../generic/common/GridItemContainerContract";
import { GridItemContainerContractNotAvailable } from "../generic/common/GridItemContainerContractNotAvailable";
import { getResourceIcon } from "../generic/icon/getResourceIcon";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
export var GridItemMarket = React.memo(function (_a) {
    var _b = _a.item, remainingTime = _b.remainingTime, rewards = _b.rewards, orders = _b.orders, visual = _b.visual, isLocked = _b.isLocked, onShowMe = _b.onShowMe, className = _a.className, onClick = _a.onClick;
    if (remainingTime || isLocked) {
        return (React.createElement("div", { className: "contract-item__wrapper" }, getContractNotAvailable(className, isLocked, remainingTime, onShowMe, onClick)));
    }
    var rewardsInfo = getRewardsInfo(rewards);
    var isContractFulfillable = orders.every(utilMarket.contractOrderFulfillable);
    return (React.createElement("div", { className: "contract-item__wrapper" },
        React.createElement(GridItemContainerContract, { className: "" + (className || ""), onClick: function () { return utilButton.onClickWithSound(onClick); } },
            React.createElement("div", { className: "contract-item" },
                React.createElement("div", { className: "contract-item__reward" },
                    visual && (React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: visual.iconAsset })),
                    isContractFulfillable && (React.createElement(Icon, { styleId: IdStyles.IconMedium, icon: IdIcon.CheckIcn }))),
                rewardsInfo))));
});
var getContractNotAvailable = function (className, isLocked, remainingTime, onShowMe, onClick) {
    var contractNotAvailableIcon = remainingTime ? IdIcon.TimeIcn : IdIcon.LockIcn;
    var contractShowMe = getContractShowMe(onShowMe);
    return (React.createElement(GridItemContainerContractNotAvailable, { className: "" + (className || ""), onClick: isLocked ? undefined : function () { return utilButton.onClickWithSound(onClick); } },
        contractShowMe,
        React.createElement("div", { className: "contract-item-disabled" },
            React.createElement(Icon, { icon: contractNotAvailableIcon, styleId: IdStyles.IconExtraLarge }))));
};
var getContractShowMe = function (onShowMe) {
    return onShowMe && (React.createElement("div", { className: "contract-item__show-me-container" },
        React.createElement("div", { className: IdStyles.TextBoldSecondary + " " + IdStyles.MarketGridItemContractShowMeLabel + " flex flex--guts" },
            React.createElement(TextLoca, { id: IdLoca.contracts_unlockAvailable })),
        React.createElement(ButtonSecondaryAccentSmall, { onClick: onShowMe },
            React.createElement("div", { className: "flex flex--guts" },
                React.createElement(Icon, { icon: IdIcon.GreenArrowIcn, styleId: IdStyles.IconSmall })))));
};
var getRewardsInfo = function (resources) {
    return resources.slice(0, 2).map(function (other, index) {
        var resourceIcon = getResourceIcon(other);
        return (React.createElement("div", { key: index, className: "contract-item__reward" },
            React.createElement(Icon, { styleId: IdStyles.IconSmall, icon: resourceIcon }),
            React.createElement("div", { className: IdStyles.TextBoldPrimary },
                React.createElement(NumberFormat, { amount: other.amount.add(other.buffAmount || Long.ZERO) }))));
    });
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/GridItemMarket.tsx
// module id = 2718
// module chunks = 3